"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _IconLibrary = require("../../packages/IconLibrary");
var _index = _interopRequireDefault(require("./index.styled"));
var _jsxRuntime = require("react/jsx-runtime");
const CloseButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  let {
    theme,
    onClick,
    ariaLabel = "OVERLAY",
    iconColor,
    backgroundColor
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.CloseButton, {
    "aria-label": `CLOSE ${ariaLabel}`,
    theme: theme,
    ref: ref,
    onClick: onClick,
    $iconColor: iconColor,
    $backgroundColor: backgroundColor,
    "data-testid": "CloseButton",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconLibrary.Close, {
      fill: iconColor || "#FFF"
    })
  });
});
var _default = exports.default = CloseButton;